import { useMemo } from 'react'

import { Dropdown } from 'core-components/library/dropdown'
import { FlexDirectionBreak } from 'core-components/sitebuilder/models/flexGrid/FlexDirectionBreak'
import { IFlexItem } from 'core-components/sitebuilder/models/flexGrid/IFlexItem'
import { BaseCrud, Static } from 'core-components/types'

import styles from './SizeSelector.module.scss'

interface ISizeSelector {
  item: IFlexItem
  value: string
  onChange: (newValue: IFlexItem) => void
}

export const SizeSelector = ({ item, value, onChange }: ISizeSelector) => {
  const source = useMemo(() => {
    return new BaseCrud({
      fetcher: new Static([
        { id: '12/12', title: '12/12' },
        { id: '11/12', title: '11/12' },
        { id: '10/12', title: '10/12' },
        { id: '9/12', title: '9/12' },
        { id: '8/12', title: '8/12' },
        { id: '7/12', title: '7/12' },
        { id: '6/12', title: '6/12' },
        { id: '5/12', title: '5/12' },
        { id: '4/12', title: '4/12' },
        { id: '3/12', title: '3/12' },
        { id: '2/12', title: '2/12' },
        { id: '1/12', title: '1/12' },
      ]),
      keyField: 'id',
      defaultPaging: {
        page: 0,
        pageSize: 12,
      },
    })
  }, [])

  return (
    <Dropdown
      classes={{ controlClasses: { root: styles.root } }}
      label="Width"
      caption="title"
      source={source}
      value={value}
      disabledInput={true}
      maxListPageSize={100}
      onChange={(newValue) => {
        onChange({
          ...item,
          size: newValue as FlexDirectionBreak,
        })
      }}
    />
  )
}
